import { useEffect, useState } from 'react'
import { Mic } from 'lucide-react'

const DEMO_TEXT =
  'Ship the landing page tonight, schedule the Show HN for Tuesday 9am, and remind me to reply to every comment in the first hour.'

/**
 * A pure-CSS macOS mock: menu bar, a notes window where dictated text types
 * itself at the cursor, and the floating AgentWhisper recording pill.
 */
export function HeroDemo() {
  const [chars, setChars] = useState(0)

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (media.matches) {
      setChars(DEMO_TEXT.length)
      return
    }
    const interval = setInterval(() => {
      setChars((current) => {
        if (current >= DEMO_TEXT.length) {
          return current
        }
        return current + 1
      })
    }, 45)
    return () => clearInterval(interval)
  }, [])

  const done = chars >= DEMO_TEXT.length

  return (
    <div className="relative mx-auto w-full max-w-xl select-none">
      {/* Glow behind the window */}
      <div className="absolute inset-0 -z-10 bg-brand-gradient opacity-20 blur-[80px]" />

      {/* macOS window */}
      <div className="overflow-hidden rounded-brand-lg border border-white/10 bg-[#13101f] shadow-2xl shadow-black/50">
        {/* Menu bar */}
        <div className="flex items-center justify-between border-b border-white/10 bg-white/5 px-4 py-2.5">
          <div className="flex items-center gap-2">
            <span className="h-3 w-3 rounded-full bg-[#ff5f57]" />
            <span className="h-3 w-3 rounded-full bg-[#febc2e]" />
            <span className="h-3 w-3 rounded-full bg-[#28c840]" />
          </div>
          <span className="text-xs font-medium text-fg-muted">Notes: Launch plan</span>
          <div className="flex items-center gap-1.5 rounded-full bg-brand-gradient-soft px-2 py-0.5">
            <img src="/app-icon.png" alt="" className="h-3.5 w-3.5" />
            <span className="text-[10px] font-semibold text-fg-dim">AgentWhisper</span>
          </div>
        </div>

        {/* Document body */}
        <div className="min-h-[200px] px-6 py-6 text-left">
          <p className="text-sm font-semibold text-fg-muted">Tuesday</p>
          <p className="mt-3 text-base leading-relaxed text-fg">
            {DEMO_TEXT.slice(0, chars)}
            <span className="demo-caret" />
          </p>
        </div>
      </div>

      {/* Floating recorder pill */}
      <div className="absolute -bottom-7 left-1/2 flex -translate-x-1/2 items-center gap-3 rounded-full border border-white/15 bg-[#1a1528]/95 px-5 py-3 shadow-xl shadow-black/40 backdrop-blur">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-gradient">
          <Mic className="h-4 w-4 text-white" />
        </span>
        {done ? (
          <span className="text-sm font-medium text-fg-dim">⌥ Space to dictate anywhere</span>
        ) : (
          <span className="flex h-5 items-end gap-1" aria-label="Recording">
            {[0.1, 0.4, 0.2, 0.6, 0.3, 0.5, 0.15].map((delay, i) => (
              <span
                key={i}
                className="wave-bar h-full"
                style={{ animationDelay: `${delay}s` }}
              />
            ))}
          </span>
        )}
        <span className="rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-fg-dim">
          100% local
        </span>
      </div>
    </div>
  )
}
